<template>
  <v-card class="elevation-2 transparent">
    <v-container container--fluid pb-0>
      <v-card-title>
        <h1>Stop Datatable</h1>
      </v-card-title>
      <v-card-actions>
        <v-row justify="space-between" no-gutters>
          <v-col md="4" cols="12">
            <v-text-field
              v-model="search"
              label="Search..."
              prepend-icon="fas fa-search"
              clearable
            >
            </v-text-field>
          </v-col>
          <v-col md="2" cols="12">
            <v-row align="center">
              <v-col cols="6" class="justify-center">
                <v-switch
                  :label="pendingSwitch ? 'Pending' : 'All'"
                  style="justify-content: center; display: flex;"
                  v-model="pendingSwitch"
                >
                </v-switch>
              </v-col>
              <v-col cols="6" class="text-center">
                <v-tooltip top color="secondary">
                  <template v-slot:activator="{ on }">
                    <v-btn large icon dark small color="blue darken-1" v-on="on" @click="showMap">
                      <v-icon large>map</v-icon>
                    </v-btn>
                  </template>
                  <span>Show map</span>
                </v-tooltip>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-container>

    <v-divider color="#42a5f5"></v-divider>

    <div v-if="searchBar">
      <v-progress-linear
        :indeterminate="true"
      ></v-progress-linear>
    </div>
    <v-alert
      :value="alert"
      type="warning"
    >
      Oops, looks like there is no delivery with those details
    </v-alert>
    <v-data-table
      :search="search"
      :headers="headers"
      :items="renderedStops"
      :sort-by="'date'"
      :sort-desc="true"
      :footer-props="{
      'page-text': 'Deliveries per page'
    }"
      @click:row="displayInfo"
    >
      <template slot="item.time" slot-scope="props">
        {{ props.item.status==='Pending' ? 'Estimated: ' + (props.item.estimated_time_updated === null ? "" : props.item.estimated_time_updated) : 'Actual: ' + (props.item.actual_time === null ? "" : props.item.actual_time) }}
      </template>
    </v-data-table>

    <v-dialog v-model="mapShown" width="800px">
      <v-card>
        <v-card-title>
          <h2>All the sites</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="mapShown=false;">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider color="#42a5f5"></v-divider>
        <v-card-text class="pb-0" v-if="mapShown" :class="{'pa-0': $vuetify.breakpoint.smAndDown}">
          <v-row justify="center">
            <v-col cols="10">
              <v-select
                class="align-center"
                v-model="zoneMap"
                :items="zoneFiltered"
                @change="reRenderMap"
                label="Zone Map"
              >
              </v-select>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="10">
              <GmapMap
                :key="keyMap"
                :center="{lat: markers[0].site_latitude, lng: markers[0].site_longitude}"
                :zoom="10"
                map-type-id="terrain"
                icon="https://www.google.dk/images/branding/googlelogo/1x/googlelogo_color_272x92dp.png"
                style="height: 75vh; width: 100%"
              >
                <GmapMarker
                  v-for="(marker, index) in markers"
                  :key="index"
                  :position="{lat: marker.site_latitude, lng: marker.site_longitude}"
                  :color="marker.status==='Processed' ? 'red' : 'grey'"
                  :clickable="true"
                  @click="openInfoWindowTemplate(marker)"
                />
                <GmapInfoWindow
                  :opened="infoWindowShown"
                  :position="infoWindow.position"
                  :options="{maxWidth: 300}"
                  @closeclick="infoWindowShown=false"
                >
                  <v-card>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <div v-for="(field, index) in Object.keys(infoWindow)" v-if="field !== 'position'">
                            <v-row justify="space-around">
                              <v-col cols="4" class="font-weight-bold">
                                {{field}}:
                              </v-col>
                              <v-col cols="8" class="text-xs-right">
                                {{Object.values(infoWindow)[index]}}
                              </v-col>
                              <br>
                            </v-row>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </GmapInfoWindow>
              </GmapMap>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <DeliveryInfoDisplayer
      :tracking="selectedTrackingNumber"
      :showProp="showInfo"
      v-on:close="showInfo=false"
      :displayShowDialog="displayShowDialog"
      :closeShowDialog="closeShowDialog"
    ></DeliveryInfoDisplayer>
  </v-card>

</template>

<script>
    import axios from 'axios'
    import DeliveryInfoDisplayer from "./DeliveryInfoDisplayer";

    export default {
        name: "StopDataTable",
        components: {
            DeliveryInfoDisplayer
        },
        props: {
            stops: Array,
            searchBar: Boolean,
            alert: Boolean,
            switchParam: Boolean,
        },
        data() {
            return {
                mapShown: false,
                zoneItems: null,
                showInfo: false,
                selectedTrackingNumber: null,
                keyMap: 0,
                infoWindow: {
                    position: {lat: 0, lng: 0},
                    client_name: null,
                    name: null,
                    actual_time: null,
                    status: null
                },
                infoWindowShown: false,
                search: '',
                pendingSwitch: this.switchParam,
                zoneMap: '',
            }
        },
        methods: {
            // filter(items, search, filter) {
            //     if (search === null || search.length === 0) return items;
            //     let terms = search.toLowerCase().split(" ");
            //     return items.filter((stop) => {
            //         for (var prop in stop) {
            //             for (var term in terms) {
            //                 if (typeof stop[prop] === 'string' || stop[prop] instanceof String) {
            //                     if (stop[prop].toLowerCase().indexOf(terms[term]) > -1) {
            //                         return true;
            //                     }
            //                 }
            //             }
            //         }
            //         return false;
            //     })
            // },
            displayInfo(row) {
                this.selectedTrackingNumber = row.tracking;
                this.showInfo = true;
            },
            displayShowDialog(){
                this.showInfo = true;
            },
            closeShowDialog(){
                this.showInfo = false;
            },
            openInfoWindowTemplate(marker) {
                this.infoWindowShown = true;
                this.infoWindow.position = {lat: marker.site_latitude, lng: marker.site_longitude};
                this.infoWindow.client_name = marker.client_name;
                this.infoWindow.name = marker.name;
                this.infoWindow.actual_time = marker.actual_time;
                this.infoWindow.status = marker.status;
            },
            showMap() {
                if (this.markers.length === 0) {
                    alert('No address was found for these search details.')
                } else {
                    this.mapShown = true;
                    // this.zoneMap = (this.zoneFiltered !== null && this.zoneFiltered !== undefined) ? this.zoneFiltered[0] : null;
                }
            },
            reRenderMap() {
                this.keyMap += 1;
            }
        },
        computed: {
            isInternalUser() {
                return this.$store.getters['auth/isInternalUser'];
            },
            admin() {
                return this.$store.getters['auth/isAdmin'];
            },
            headers() {
                let headers = [
                    {text: 'Service', value: 'service_name', align: 'center'},
                    {text: 'Run Sort Code', value: 'run_sort_code', align: 'center'},
                    {text: 'Name', value: 'name', align: 'center'},
                    {text: 'Address', value: 'street1', align: 'center'},
                    {text: 'Depot', value: 'depot_name', align: 'center'},
                    {text: 'Zone', value: 'zone_name', align: 'center'},
                    {text: 'Invoice No', value: 'invoice', align: 'center'},
                    {text: 'Tracking Id', value: 'tracking', align: 'center'},
                    {text: 'Date', value: 'date', align: 'center'},
                    {text: 'Status', value: 'status', align: 'center'},
                    {text: 'Time', value: 'time', align: 'center'},
                ];

                if (this.isInternalUser) {
                    headers.unshift({text: 'Client Name', value: 'client_name', align: 'center'});
                }

                return headers;
            },
            renderedStops() {
                return this.stops.filter((stop) => {
                    if (this.pendingSwitch) {
                        return stop.status === 'Pending';
                    } else {
                        return true
                    }
                }).map((stop) => {
                    stop.time = (new Date(stop.actual_time).getTime());
                    if (isNaN(stop.time)) stop.time = 0;
                    return stop;
                })
            },
            zoneFiltered() {
                // We only take the one with where stops have geocodes
                return this.stops.filter((stop) => {
                    return stop.site_latitude !== undefined && stop.site_longitude !== undefined
                        && stop.site_latitude !== null && stop.site_longitude !== null
                }).map((stop) => {
                    return stop.zone_name
                })
            },
            //
            // zoneMap() {
            //   if (this.zoneFiltered.length === 1) {
            //     return this.zoneFiltered[0]
            //   }
            //   return null
            // },

            markers() {
                // Only taking the stops with defined geocodes
                let effectiveZoneMap = null;
                if (this.zoneMap === '' && this.zoneFiltered !== null && this.zoneFiltered !== undefined) {
                    effectiveZoneMap = this.zoneFiltered[0];
                } else {
                    effectiveZoneMap = this.zoneMap;
                }
                return this.stops.filter((stop) => {
                    return (stop.zone_name === effectiveZoneMap && stop.site_latitude !== undefined && stop.site_longitude !== undefined
                        && stop.site_latitude !== null && stop.site_longitude !== null)
                })
                //   .map((elt) => {
                //   return {
                //     position: {lat: parseFloat(elt.site_latitude), lng: parseFloat(elt.site_longitude)},
                //     status: elt.status
                //   }
                // })
            }
        },

        mounted() {
            if (this.$route.query.tracking !== null && this.$route.query.tracking !== undefined) {
                this.selectedTrackingNumber = this.$route.query.tracking;
                this.showInfo = true;
            }
        },
    }


</script>

<style scoped>
  .v-data-table >>> tbody tr {
    cursor: pointer;
  }
  .v-data-table >>> tbody tr:nth-of-type(even) {
    background-color: #f2f5f7;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Search/StopDataTable.vue